import {useAuth} from '@common/auth/use-auth';
import {AccountSettingsPanel} from '../account-settings-panel';
import {Button} from '@ui/buttons/button';
import {Trans} from '@ui/i18n/trans';
import {useSettings} from '@ui/settings/use-settings';
import React from 'react';

export function CreditsPanel({
  user,
}: {
  user: {
    available_credits: number;
  };
}) {
  const {hasPermission} = useAuth();
  const {api} = useSettings();

  if (!api?.integrated || !hasPermission('api.access')) return null;

  return (
    <AccountSettingsPanel
      id="account-credits"
      title={<Trans message="Available credits" />}
    >
      <div className="flex flex-col gap-16">
        <div className="text-lg">
          <span className="text-2xl font-semibold">
            {user.available_credits}
          </span>
          <span className="ml-8 text-sm text-muted">
            <Trans message="credits" />
          </span>
        </div>
        <div>
          <Button
            variant="flat"
            color="primary"
            onClick={() =>
              (window.location.href =
                'https://www.folderfort.com/shop/api-credits/')
            }
          >
            <Trans message="Buy credits" />
          </Button>
        </div>
      </div>
    </AccountSettingsPanel>
  );
}
